module.exports = __webpack_public_path__ + "website/img/topBg_l.043afe2f.png";